export const isLiftsUrlWhiteListed = (liftsUrl?: string | null) => (liftsUrl || '').indexOf('&iu=/7730') >= 0;

export default isLiftsUrlWhiteListed;
